__turbopack_context__.v({
  "error-message": "textfield-module-scss-module__aKKbDq__error-message",
  "field-wrapper": "textfield-module-scss-module__aKKbDq__field-wrapper",
  "footer": "textfield-module-scss-module__aKKbDq__footer",
  "forced-error": "textfield-module-scss-module__aKKbDq__forced-error",
  "input": "textfield-module-scss-module__aKKbDq__input",
  "input-centered": "textfield-module-scss-module__aKKbDq__input-centered",
  "input-wrapper": "textfield-module-scss-module__aKKbDq__input-wrapper",
  "label": "textfield-module-scss-module__aKKbDq__label",
  "label-centered": "textfield-module-scss-module__aKKbDq__label-centered",
  "placeholder": "textfield-module-scss-module__aKKbDq__placeholder",
  "slot": "textfield-module-scss-module__aKKbDq__slot",
  "wrapper": "textfield-module-scss-module__aKKbDq__wrapper",
});
